// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q0LGn","label":"styles_label__2g_Kr"};